import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-60526812"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "component-socket-value component-socket-value--medium" };
const _hoisted_2 = { class: "component-display-name-wrapper" };
const _hoisted_3 = {
    key: 0,
    class: "display-name-text"
};
const _hoisted_4 = { class: "icon-wrapper socket-controls" };
import { useRewardSupplier } from "src/shared/store/reward/supplier/composables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'RewardSupplierDisplayName',
    props: {
        rewardSupplierId: {}
    },
    emits: ["remove"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const { rewardSupplier } = useRewardSupplier(props.rewardSupplierId);
        const emits = __emit;
        const removeSelection = (rewardSupplierId) => {
            emits("remove", rewardSupplierId);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h3", _hoisted_2, [
                    (_unref(rewardSupplier))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(rewardSupplier).name) + _toDisplayString(_unref(rewardSupplier).getFormattedValue()
                            ? ` (${_unref(rewardSupplier).getFormattedValue()})`
                            : _unref(rewardSupplier).face_value
                                ? ` (${_unref(rewardSupplier).face_value})`
                                : ""), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("i", {
                        class: "fal fa-trash",
                        onClick: _cache[0] || (_cache[0] = () => removeSelection(_unref(rewardSupplier).id))
                    })
                ])
            ]));
        };
    }
});
